<template>
    <div class="bill-manage-container" v-loading="loading">
        <!-- Data Table Card -->
        <el-card class="table-card" shadow="hover">
            <template #header>
                <div class="card-header">
                    <div class="card-title">
                        <div class="title-row">
                            <el-icon><List /></el-icon>
                            账单数据
                            <span class="record-count">共 {{ pageparm.total }} 条记录</span>
                        </div>
                        <div class="filter-content" ref="tableSelect">
                            <div class="content-layout">
                                <div class="filter-section">
                                    <el-form :inline="true" :model="formInline" label-position="top" class="filter-form">
                                        <div class="filter-grid">
                                            <!-- Date -->
                                            <div class="filter-item date-picker-container">
                                                <el-form-item label="日期" class="filter-form-item">
                                                    <el-date-picker  
                                                        class="date-picker"
                                                        @change="search"
                                                        format="YYYY-MM"
                                                        value-format="YYYYMM"
                                                        v-model="formInline.month"
                                                        type="month"
                                                        placeholder="选择月份">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </div>

                                            <!-- Region -->
                                            <div class="filter-item">
                                                <el-form-item label="地区" class="filter-form-item">
                                                    <el-select v-model="formInline.region" clearable @change="search" placeholder="请选择地区" class="filter-select">
                                                        <el-option
                                                            v-for="(item,index) in regionList"
                                                            :key="index"
                                                            :label="item.label"
                                                            :value="item.value"
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>

                                            <!-- Payers -->
                                            <div class="filter-item" v-if="curRole!='customer'">
                                                <el-form-item label="Payers" class="filter-form-item">
                                                    <el-select v-model="formInline.payer_id" clearable filterable @change="search" placeholder="请选择Payers" class="filter-select">
                                                        <el-option
                                                            v-for="(item,index) in payersList"
                                                            :key="index"
                                                            :label="item.name+'('+item.payer_id+')'"
                                                            :value="item.payer_id"
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>

                                            <!-- Sales -->
                                            <div class="filter-item" v-if="curRole=='admin'">
                                                <el-form-item label="销售" class="filter-form-item">
                                                    <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择销售" @change="search" class="filter-select">
                                                        <el-option
                                                            v-for="item in salesList"
                                                            :key="item.id"
                                                            :label="item.name"
                                                            :value="item.name"
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>

                                            <!-- Partners -->
                                            <div class="filter-item" v-if="curRole=='admin'||curRole=='sales'">
                                                <el-form-item label="合作伙伴" class="filter-form-item">
                                                    <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择合作伙伴" @change="search" class="filter-select">
                                                        <el-option
                                                            v-for="item in agentsList"
                                                            :key="item.agent_id"
                                                            :label="item.company"
                                                            :value="item.agent_id"
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>

                                            <!-- Bill Type -->
                                            <div class="filter-item">
                                                <el-form-item label="账单类型" class="filter-form-item">
                                                    <el-select filterable v-model.trim="formInline.billType" placeholder="请选择账单类型" @change="search" class="filter-select">
                                                        <el-option
                                                            v-for="item in billTypeList"
                                                            :key="item.value"
                                                            :label="item.name"
                                                            :value="item.value"
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>

                                            <!-- LinkId -->
                                            <div class="filter-item">
                                                <el-form-item label="LinkId" class="filter-form-item">
                                                    <el-input 
                                                        v-model="formInline.link_id" 
                                                        clearable 
                                                        @change="search" 
                                                        placeholder="请输入LinkId"
                                                        class="filter-input">
                                                    </el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </el-form>
                                    <!-- Search Buttons -->
                                    <div class="search-buttons">
                                        <el-button @click="search" type="primary" icon="Search" size="small" class="search-btn">
                                            查询
                                        </el-button>
                                        <el-button @click="reset" icon="Refresh" size="small" class="reset-btn">
                                            重置
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="action-buttons">
                        <el-button @click="selected.length>0?downloadTheBillByUrl(1):downloadTheBillByUrl(2)" type="primary" class="action-btn">
                            <el-icon class="custom-icon"><Document /></el-icon>
                            下载账单
                        </el-button>
                        <el-button @click="selected.length>0?downloadRightBill(1):downloadRightBill(2)" type="success" class="action-btn">
                            <el-icon class="custom-icon"><Tickets /></el-icon>
                            下载对账单
                        </el-button>
                        <el-button @click="selected.length>0?downloadPdfInvoice(1):downloadPdfInvoice(2)" type="info" class="action-btn">
                            <el-icon class="custom-icon"><Document /></el-icon>
                            下载PDF账单
                        </el-button>
                        <el-button v-if="curRole!='customer'" :disabled="!canConfirm" @click="confirmBill" type="warning" class="action-btn">
                            <el-icon class="custom-icon"><Check /></el-icon>
                            确认账单
                        </el-button>
                    </div>
                </div>
            </template>

            <div class="table-container">
                <el-table 
                    :height="isCollapse ? 'calc(100vh - 180px)' : 'calc('+(tableHeight - 150)+'px)'" 
                    stripe 
                    :data="tableData" 
                    ref="tableref" 
                    v-loading="loadingPage" 
                    @selection-change="selectionChange" 
                    @sort-change="handleSortChange"
                    class="modern-table">
                    
                    <el-table-column type="selection" width="50"></el-table-column>

                    <el-table-column label="LinkerId" prop="linkId" min-width="160">
                        <template #default="scope">
                            <div class="link-cell">
                                <div class="status-indicator">
                                    <el-tooltip :content="computeDate()?'销售待确认':'账单未生成'" placement="right" v-if="scope.row.locked==0||scope.row.locked==null">
                                        <div class="status-dot" :class="computeDate()?'warning':'info'"></div>
                                    </el-tooltip>
                                    <el-tooltip content="伙伴待确认" placement="right" v-if="scope.row.locked==1">
                                        <div class="status-dot primary"></div>
                                    </el-tooltip>
                                    <el-tooltip content="伙伴已拒绝" placement="right" v-if="scope.row.locked==3">
                                        <div class="status-dot danger"></div>
                                    </el-tooltip>
                                    <el-tooltip content="账单已确认" placement="right" v-if="scope.row.locked==2">
                                        <div class="status-dot success"></div>
                                    </el-tooltip>
                                </div>
                                <span class="link-id" v-if="curRole=='customer'">{{ scope.row.linkId }}</span>
                                <span class="link-id clickable" v-if="curRole!='customer'" @click="showInvoiceDialog(scope.row.linkId)">{{ scope.row.linkId }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="客户名称" prop="company" min-width="200">
                        <template #default="scope">
                            <div class="cell-content">
                                <span class="company-name" :title="scope.row.company">{{ scope.row.company }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="Payer Name" prop="payerId" min-width="200">
                        <template #default="scope">
                            <div class="cell-content">
                                <span v-if="scope.row.payerId">{{ payersList.filter(item=>item.payer_id==scope.row.payerId)[0]?.name }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="类别" prop="entity" min-width="120">
                        <template #default="scope">
                            <div class="cell-content">
                                <el-tag size="small" class="entity-tag">{{ scope.row.entity }}</el-tag>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="账单年月" prop="month" min-width="100">
                        <template #default="scope">
                            <div class="cell-content">
                                <span class="date-text">{{ scope.row.month.toString().substring(0,4)+'-'+scope.row.month.toString().substring(4,6) }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="Charge" prop="charge" min-width="120" align="right" sortable="custom">
                        <template #default="scope">
                            <div class="amount-cell">
                                <span class="amount">{{ Number(scope.row.charge).toFixed(2) }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column v-if="!(curRole=='customer'&&!showCredit)" label="Credit" prop="credit" min-width="120" align="right" sortable="custom">
                        <template #default="scope">
                            <div class="amount-cell">
                                <span class="amount">{{ Number(scope.row.credit).toFixed(2) }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="Discount" prop="discount_distributor" min-width="120" align="right" sortable="custom">
                        <template #default="scope">
                            <div class="amount-cell">
                                <span class="amount discount">{{ Number(scope.row.discount_distributor).toFixed(2) }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="Tax" prop="tax" min-width="100" align="right" sortable="custom">
                        <template #default="scope">
                            <div class="amount-cell">
                                <span class="amount">{{ Number(scope.row.tax).toFixed(2) }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column v-if="!(curRole=='customer'&&!showSavingPlan)" label="SavingPlans" prop="spNegation" min-width="120" align="right" sortable="custom">
                        <template #default="scope">
                            <div class="amount-cell">
                                <span class="amount saving-plan">{{ Number(scope.row.spNegation).toFixed(2) }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column v-if="!(curRole=='customer'&&!showBundle)" label="Bundle" prop="bundledDiscount" min-width="120" align="right" sortable="custom">
                        <template #default="scope">
                            <div class="amount-cell">
                                <span class="amount">{{ Number(scope.row.bundledDiscount).toFixed(2) }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="TotalCost" prop="costTotal" min-width="130" align="right" sortable="custom">
                        <template #default="scope">
                            <div class="amount-cell">
                                <span class="amount total">{{ Number(scope.row.costTotal).toFixed(2) }}</span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" fixed="right" width="140" align="center" v-if="curRole!='customer'">
                        <template #default="scope">
                            <div class="action-cell" v-if="(this.curRole=='sales'||this.curRole=='admin')&&(scope.row.locked==0 || scope.row.locked==null|| scope.row.locked==3)">
                                <el-tooltip content="重新计算账单" placement="top">
                                    <el-button :disabled="canCompute" type="primary" size="small" class="action-icon-btn" @click="reCompute(scope.row.payerId,scope.row.linkId)">
                                        <el-icon><Calculator /></el-icon>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="重新下载原始账单" placement="top">
                                    <el-button :disabled="canDownload" type="success" size="small" class="action-icon-btn" @click="reDownload(scope.row.payerId,scope.row.linkId)">
                                        <el-icon><Download /></el-icon>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="添加增值服务" placement="top">
                                    <el-button size="small" class="action-icon-btn" @click="addService(scope.row)" type="warning">
                                        <el-icon><Plus /></el-icon>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="修改返点" placement="top">
                                    <el-button size="small" class="action-icon-btn" @click="edit(scope.row)" type="info">
                                        <el-icon><Money /></el-icon>
                                    </el-button>
                                </el-tooltip>
                            </div>
                            <el-tooltip v-if="curRole=='agent'&&scope.row.locked==1" content="拒绝账单" placement="top">
                                <el-button size="small" class="action-icon-btn" @click="refuseBill(scope.row.id)" type="danger">
                                    <el-icon><CircleCloseFilled /></el-icon>
                                </el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="table-footer">
                <div class="pagination-wrapper">
                    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
                </div>
            </div>
        </el-card>

        <!-- Service Dialog -->
        <el-dialog width="60%" class="service-dialog" v-model="serviceVisible" :close-on-click-modal="false" title="VAP增值服务">
            <el-table stripe :data="serviceData" class="service-table">
                <el-table-column label="服务描述">
                    <template #default="scope">
                        {{ scope.row.serviceName }}
                    </template>
                </el-table-column>
                <el-table-column label="税前金额" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.cost).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="税点" align="right">
                    <template #default="scope">
                        {{ (Number(scope.row.tax)*100).toFixed(2)+'%' }}
                    </template>
                </el-table-column>
                <el-table-column label="总计" align="right">
                    <template #default="scope">
                        {{ Number(scope.row.costAgent).toFixed(2) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120">
                    <template #default="scope">
                        <el-button type="primary" size="small" @click="editService(scope.row)" icon="Edit">编辑</el-button>
                        <el-button type="danger" size="small" @click="removeService(scope.row)" icon="Delete">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class="service-form">
                <el-form :inline="false" :model="addForm" label-position="right" label-width="80px">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="税前金额">
                                <el-input v-model="addForm.cost" @input="costChange" placeholder="请输入税前金额"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="税点">
                                <el-input v-model="addForm.tax" @input="taxChange" placeholder="请输入税点">
                                    <template #append>%</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="总计">
                                <el-input type="number" v-model="addCostTotal" readonly disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="描述">
                                <el-input maxlength="10" v-model="addForm.serviceName" placeholder="请输入描述"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="init">新增服务</el-button>
                    <el-button type="primary" @click="isEditService?editServiceSubmit():addServiceSubmit()">提交</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- Rebate Edit Dialog -->
        <el-dialog 
            v-model="dialogVisible" 
            :close-on-click-modal="false" 
            :before-close="cancel" 
            :width="curRole=='agent'?'700px':'1000px'"
            class="edit-dialog">
            
            <template #header>
                <div class="dialog-header">
                    <h3 class="dialog-title">
                        <el-icon><Edit /></el-icon>
                        修改返点
                        <span class="dialog-subtitle">
                            {{ curType == 2 ? '- ' + formInline.month : '- 默认日期' }}
                        </span>
                    </h3>
                </div>
            </template>

            <div class="dialog-content">
                <el-form :inline="false" :model="formData" ref="rulesForm" label-position="right" label-width="140px" class="edit-form"> 
                    <!-- Admin/Sales View -->
                    <div v-if="curRole=='admin'||curRole=='sales'" class="form-section">
                        <h4 class="section-title">基础返点设置</h4>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="VAP返点" prop="discount1">
                                    <el-input v-model="formData.discount1" readonly disabled class="disabled-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="伙伴返点" prop="discount2">
                                    <el-input 
                                        v-model="formData.discount2" 
                                        @input="(v)=>(formData.discount2=v.replace(/[^\d.]/g,''))" 
                                        placeholder="如: 0.25"
                                        class="editable-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="客户返点" prop="discount3">
                                    <el-input 
                                        v-model="formData.discount3" 
                                        @input="(v)=>(formData.discount3=v.replace(/[^\d.]/g,''))" 
                                        placeholder="如: 0.25"
                                        class="editable-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                        <h4 class="section-title">服务返点设置</h4>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="VAP服务返点" prop="sb_discount1">
                                    <el-input v-model="formData.sb_discount1" readonly disabled class="disabled-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="伙伴服务返点" prop="sb_discount2">
                                    <el-input 
                                        v-model="formData.sb_discount2" 
                                        @input="(v)=>(formData.sb_discount2=v.replace(/[^\d.]/g,''))" 
                                        placeholder="如: 0.25"
                                        class="editable-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="客户服务返点" prop="sb_discount3">
                                    <el-input 
                                        v-model="formData.sb_discount3" 
                                        @input="(v)=>(formData.sb_discount3=v.replace(/[^\d.]/g,''))" 
                                        placeholder="如: 0.25"
                                        class="editable-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                        <h4 class="section-title">屏蔽设置</h4>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="屏蔽Credit" prop="credit">
                                    <el-switch
                                        v-model="formData.credit"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="是"
                                        inactive-text="否"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="屏蔽RI" prop="ri">
                                    <el-switch
                                        v-model="formData.ri"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="是"
                                        inactive-text="否"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="屏蔽SP" prop="sp">
                                    <el-switch
                                        v-model="formData.sp"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="是"
                                        inactive-text="否"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="屏蔽Bundle" prop="bundle">
                                    <el-radio-group v-model="formData.bundle" class="setting-radio">
                                        <el-radio :label="0">否</el-radio>
                                        <el-radio :label="1">仅屏蔽客户</el-radio>
                                        <el-radio :label="2">均屏蔽</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                        <el-row v-if="curType==1" :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="截止日期" prop="monthEnd">
                                    <el-date-picker 
                                        format="YYYY-MM"
                                        value-format="YYYYMM"
                                        v-model="formData.monthEnd"
                                        type="month"
                                        placeholder="选择截止日期"
                                        style="width: 100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- Agent View -->
                    <div v-if="curRole=='agent'" class="form-section">
                        <h4 class="section-title">返点设置</h4>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="伙伴返点" prop="discount2">
                                    <el-input v-model="formData.discount2" readonly disabled class="disabled-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="客户返点" prop="discount3">
                                    <el-input 
                                        v-model="formData.discount3" 
                                        @input="(v)=>(formData.discount3=v.replace(/[^\d.]/g,''))" 
                                        placeholder="如: 0.25"
                                        class="editable-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                        <h4 class="section-title">服务返点设置</h4>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="伙伴服务返点" prop="sb_discount2">
                                    <el-input v-model="formData.sb_discount2" readonly disabled class="disabled-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="客户服务返点" prop="sb_discount3">
                                    <el-input 
                                        v-model="formData.sb_discount3" 
                                        @input="(v)=>(formData.sb_discount3=v.replace(/[^\d.]/g,''))" 
                                        placeholder="如: 0.25"
                                        class="editable-input">
                                        <template #append>%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                        <h4 class="section-title">屏蔽设置</h4>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="屏蔽Credit" prop="credit">
                                    <el-switch
                                        v-model="formData.credit"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="是"
                                        inactive-text="否"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="屏蔽RI" prop="ri">
                                    <el-switch
                                        v-model="formData.ri"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="是"
                                        inactive-text="否"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="屏蔽SP" prop="sp">
                                    <el-switch
                                        v-model="formData.sp"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="是"
                                        inactive-text="否"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="屏蔽Bundle" prop="bundle">
                                    <el-radio-group v-model="formData.bundle" class="setting-radio">
                                        <el-radio :label="0">否</el-radio>
                                        <el-radio :label="1">仅屏蔽客户</el-radio>
                                        <el-radio :label="2">均屏蔽</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>

            <template #footer>
                <div class="dialog-footer">
                    <div class="footer-note">
                        <el-icon><InfoFilled /></el-icon>
                        <span v-if="curType==2">注：此处修改仅当月有效</span>
                        <span v-else>注：请确认该账户返点是否固定，此处修改下月至截止日期，返点将保持修改后的返点</span>
                    </div>
                    <div class="footer-actions">
                        <el-button @click="cancel()" size="large">取消</el-button>
                        <el-button type="primary" @click="submit" size="large">确定</el-button>
                    </div>
                </div>
            </template>
        </el-dialog>

        <el-dialog
            title="账单详情"
            v-model="invoiceDialogVisible"
            width="50%"
            :before-close="handleClose">
            <BillInvoiceView v-if="invoiceDialogVisible" :link-id="selectedLinkId" :month="formInline.month" :bill-type="formInline.billType" />
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="invoiceDialogVisible = false">关 闭</el-button>
              </span>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {downloadBillByBlob,downloadBillByUrl,getBillList,downloadBillDetail,reGenerateBill,reDownloadBill,saleConfirmBill,
        agentConfirmBill,getServiceData,addServiceBill,delServiceBill,getSalesList,getAgentList,getPayerList,updateCheckRebate, getCheckRebateList,downloadPdfBill} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    import { Money, InfoFilled, Document, Tickets, Check, Calculator, Download, Plus, CircleCloseFilled } from '@element-plus/icons-vue'
    import BillInvoiceView from './components/BillInvoiceView.vue';

    export default {
        components:{
            Pagination,
            BillInvoiceView,
        },
        name:'billManage',
        data() {
            return {
                isCollapse: false,
                loading:false,
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    month:'',
                    region:'',
                    payer_id:'',
                    link_id:'',
                    sales:'',
                    agent_id:'',
                    billType:2,
                    page: 1,
                    limit: 20,
                    sortBy: '',
                    sortOrder: '',
                },
                addForm:{
                    cost:'',
                    tax:'',
                },
                addCostTotal:0,
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                tableData:[],
                payersList:[],
                salesList:[],
                agentsList:[],
                billTypeList:[
                    {name:'总代应付',value:1},
                    {name:'伙伴应付',value:2},
                    {name:'客户应付',value:3},
                ],
                regionList:[
                    {label:'全部',value:''},
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'}
                ],
                curRole:localStorage.getItem('curRole'),
                curDate:'',
                selected:[],
                canConfirm:false,

                showCredit:true,
                showSavingPlan:true,
                showBundle:true,
                serviceVisible:false,
                curRow:null,
                serviceData:null,
                isEditService:false,
                confirmSelected:[],
                canCompute:false,
                canDownload:false,
                dialogVisible: false,
                curType: '2',
                typeList:[
                    {label:'默认',value:'1'},
                    {label:'日期',value:'2'},
                ],
                formData: {
                    discount1: '',
                    discount2: '',
                    discount3: '',
                    sb_discount1: '',
                    sb_discount2: '',
                    sb_discount3: '',
                    credit: 0,
                    ri: 0,
                    sp: 0,
                    bundle: 0,
                    linkId: '',
                    monthEnd: ''
                },
                invoiceDialogVisible: false,
                selectedLinkId: null,
            }
        },

        computed: {
            // No longer needed computed properties have been removed
        },
        
        created() {
            this.permissionData();
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取当前月
            let endM = (date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1 ) : date.getMonth()+1);
            let endD = date.getDate()<10?'0'+date.getDate():date.getDate();
            // 获取当前时间的时间戳
            this.curDate=(new Date(endY+'-'+endM+'-'+endD).getTime())/1000;
            this.formInline.month=endY.toString()+endM.toString();
            if(localStorage.getItem('billManageForm')){
                this.formInline = JSON.parse(localStorage.getItem('billManageForm'))
            }
            if(this.curRole=='sales'){
                this.formInline.sales = localStorage.getItem('account')
            }else if(this.curRole == 'agent'){
                this.formInline.agent_id = localStorage.getItem('account');
                this.billTypeList=[
                    {name:'伙伴应付',value:2},
                    {name:'客户应付',value:3},
                ]
            }else if(this.curRole == 'customer'){
                this.billTypeList=[
                    {name:'客户应付',value:3},
                ]
                this.formInline.billType = 3;
            }
            this.getData();
        },
        methods:{
            //获取列表
            getData() {
                this.loadingPage = true;
                this.tableData = [];
                // 只保留有值的参数
                let params = {};
                Object.keys(this.formInline).forEach(key => {
                    if (this.formInline[key] !== '' && this.formInline[key] !== null && this.formInline[key] !== undefined) {
                        params[key] = this.formInline[key];
                    }
                });
                getBillList(params).then(res => {
                    if(res.code ==2000) {
                        // 兼容后端返回data为对象的情况
                        if(res.data && Array.isArray(res.data.data)) {
                            this.tableData = res.data.data;
                            this.pageparm.page = res.data.page;
                            this.pageparm.limit = res.data.limit;
                            this.pageparm.total = res.data.total;
                        } else if(Array.isArray(res.data)) {
                            this.tableData = res.data;
                        } else {
                            this.tableData = [];
                        }
                        var num1=0,num2=0,num3=0;
                        this.tableData.forEach(el=>{
                            num1 = Number(num1) + Number(el.credit);
                            num2 = Number(num2) + Number(el.spNegation);
                            num3 = Number(num3) + Number(el.bundledDiscount);
                        })
                        if(num1==0){
                            this.showCredit = false;
                        }
                        if(num2==0){
                            this.showSavingPlan = false;
                        }
                        if(num3==0){
                            this.showBundle = false;
                        }
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                        this.tableData = [];
                    }
                    this.loadingPage = false;
                }).catch(err => {
                    this.loadingPage = false;
                    this.tableData = [];
                });
            },
            permissionData(){
                if(this.curRole=='admin'){
                    this.getAgentsList();
                    this.getSaleList();
                    this.getPayersList();
                }else if(this.curRole == 'sales'){
                    this.getAgentsList();
                    this.getPayersList();
                }else if(this.curRole == 'agent'){
                    this.getPayersList();
                }
            },
            // 获取伙伴列表
            getAgentsList(){
                getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.agentsList = res.data.data;
                    }else{
                        this.$message.error('获取伙伴列表失败！');
                    }
                })
            }, 
            // 获取销售列表
            getSaleList(){
                getSalesList({name:'',phone:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.salesList = res.data.data;
                    }else{
                        this.$message.error('获取销售列表失败！');
                    }
                })
            },
            // 获取payer列表
            getPayersList(){
                getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payersList = res.data.data;
                    }else{
                        this.$message.error('获取Payer列表失败！');
                    }
                })
            }, 
            // 通过文件流下载
            downloadTheBillByBlob(type,linkId){
                if(linkId){//点击linkId下载单个
                    downloadBillByBlob({link_id:linkId,month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                        if(res.size<=73){
                            this.$message.error('无账单文件，请联系管理员！')
                        }else{
                            const url = window.URL.createObjectURL(res) // 将二进制文件转换为可访问的url
                            const a = document.createElement('a')
                            document.body.appendChild(a)
                            a.href = url
                            a.download = '单个账单.zip'
                            a.click()
                            window.URL.revokeObjectURL(url)
                        }
                    })
                }else{
                    if(type==1){//下载选中账单
                        var arr=[];
                        this.selected.forEach(el=>{
                            arr.push(el.linkId)
                        })
                        downloadBillByBlob({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                            if(res.size<=73){
                                this.$message.error('无账单文件，请联系管理员！')
                            }else{
                                const url = window.URL.createObjectURL(res) // 将二进制文件转换为可访问的url
                                const a = document.createElement('a')
                                document.body.appendChild(a)
                                a.href = url
                                a.download = '单个账单.zip'
                                a.click()
                                window.URL.revokeObjectURL(url)
                            }
                        })
                    }else{//下载全部账单
                        downloadBillByBlob(this.formInline).then(res=>{
                            if(res.size<=73){
                                this.$message.error('无账单文件，请联系管理员！')
                            }else{
                                const url = window.URL.createObjectURL(res) // 将二进制文件转换为可访问的url
                                const a = document.createElement('a')
                                document.body.appendChild(a)
                                a.href = url
                                a.download = '单个账单.zip'
                                a.click()
                                window.URL.revokeObjectURL(url)
                            }
                        })
                    }
                }
            },
            // 通过地址下载
            downloadTheBillByUrl(type,linkId){
                this.loading = true;
                if(linkId){//点击linkId下载单个
                    downloadBillByUrl({link_id:linkId,month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }else{
                    if(type==1){//下载选中账单
                        var arr=[];
                        this.selected.forEach(el=>{
                            arr.push(el.linkId)
                        })
                        downloadBillByUrl({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                            this.loading = false;
                            if(res.code==2000){
                                if(res.data){
                                    this.downloadFile(res.data)
                                }else{
                                    this.$message.error(JSON.stringify(res.msg));
                                }
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }else{//下载全部账单
                        downloadBillByUrl(this.formInline).then(res=>{
                            this.loading = false;
                            if(res.code==2000){
                                if(res.data){
                                    this.downloadFile(res.data)
                                }else{
                                    this.$message.error(JSON.stringify(res.msg));
                                }
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }
                }
            },
            // 下载
            downloadFile(url){
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.href = url
                a.click()
                setTimeout(()=>{
                    a.remove()
                },1000)
            },
            // PDF下载 - 在新标签页打开
            downloadPdfFile(url){
                window.open(url, '_blank')
            },
            isRowSelectable(row,index){
                if(this.curRole=='agent'){
                    return row.locked==1
                }else{
                    return row.locked==0 && this.computeDate();
                }
                
            },
            // 复选框勾选
            selectionChange(val){
                this.selected=val;
                if(this.selected.length>0){
                    if(this.curRole=='agent'){
                        this.confirmSelected = val.filter(item=>{
                            return item.locked == 1;
                        })
                    }else{
                        this.confirmSelected = val.filter(item=>{
                            return (item.locked==0||item.locked==3) && this.computeDate();
                        })
                    }
                    if(this.confirmSelected.length>0){
                        this.canConfirm = true;
                    }else{
                        this.canConfirm = false;
                    }
                }else{
                    this.canConfirm = false;
                }
            },
            // 重新计算账单
            reCompute(payerId,linkId){
                this.canCompute = true;
                reGenerateBill({month:this.formInline.month,payerId:payerId,linkId:linkId}).then(res=>{
                    if(res.code ==2000){
                        this.$message.success(res.msg);
                        this.canCompute = false;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 重新下载原始账单
            reDownload(payerId,linkId){
                this.canDownload = true;
                reDownloadBill({month:this.formInline.month,payerId:payerId,linkId:linkId}).then(res=>{
                    if(res.code ==2000){
                        this.$message.success(res.msg);
                        this.canDownload = false;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            downloadRightBill(type){
                this.loading = true;
                if(type==1){//下载选中账单
                    var arr=[];
                    this.selected.forEach(el=>{
                        arr.push(el.linkId)
                    })
                    downloadBillDetail({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }else{//下载全部账单
                    downloadBillDetail(this.formInline).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }
            },
            downloadPdfInvoice(type){
                this.loading = true;
                if(type==1){//下载选中账单PDF
                    var arr=[];
                    this.selected.forEach(el=>{
                        arr.push(el.linkId)
                    })
                    downloadPdfBill({link_id:arr.join(','),month:this.formInline.month,billType:this.formInline.billType}).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadPdfFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }else{//下载全部账单PDF
                    downloadPdfBill(this.formInline).then(res=>{
                        this.loading = false;
                        if(res.code==2000){
                            if(res.data){
                                this.downloadPdfFile(res.data)
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }
            },
            addService(obj){
                this.curRow = JSON.parse(JSON.stringify(obj));
                this.getSData();
                setTimeout(()=>{
                    this.serviceVisible = true;
                    this.isEditService = false;
                },200)
            },
            getSData(linkId){
                getServiceData({linkId:this.curRow.linkId,month:this.formInline.month}).then(res=>{
                    if(res.code==2000){
                        this.serviceData = res.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            init(){
                this.addForm={
                    cost:'',
                    tax:'',
                    serviceName:'',
                }
                this.addCostTotal = 0;
                this.isEditService =false;
            },
            costChange(val){
                this.addForm.cost = val.replace(/[^\d.]/g,'');
                if(this.addForm.tax){
                    this.addCostTotal =((Number(this.addForm.cost) * (Number(this.addForm.tax)+100))/100).toFixed(2);
                }else{
                    this.addCostTotal = this.addForm.cost;
                }
            },
            taxChange(val){
                this.addForm.tax = val.replace(/[^\d.]/g,'');
                if(this.addForm.cost){
                    this.addCostTotal =((Number(this.addForm.cost) * (Number(this.addForm.tax)+100))/100).toFixed(2);
                }else{
                    this.addCostTotal = 0;
                }
            },
            addServiceSubmit(){
                var obj={
                    linkId:this.curRow.linkId,
                    payerId:this.curRow.payerId,
                    month:this.formInline.month,
                    serviceCode:this.addForm.serviceName,
                    entity:this.curRow.entity
                }
                this.addForm.tax = this.addForm.tax / 100;
                addServiceBill({...obj,...this.addForm}).then(res=>{
                    if(res.code==2000){
                        this.$message.success('添加服务成功！');
                        this.init();
                        this.getSData();
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            editService(obj){
                this.addForm = JSON.parse(JSON.stringify(obj));
                this.addForm.tax = this.addForm.tax*100;
                this.isEditService = true;
            },
            removeService(obj){
                this.$confirm('确定删除该服务吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(()=>{
                    delServiceBill({id:obj.id,linkId:obj.linkId}).then(res=>{
                        if(res.code==2000){
                            this.getSData();
                            this.$message.success('删除成功！')
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                })
            },
            editServiceSubmit(){
                this.addForm.tax = this.addForm.tax / 100;
                addServiceBill(this.addForm).then(res=>{
                    if(res.code==2000){
                        this.$message.success('修改服务成功！');
                        this.init();
                        this.getSData();
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },

            confirmBill(){
                var txt="账单一经确认，将会锁定账单且无法修改，是否继续？";
                if(this.curRole == 'agent'){
                    txt = '橘色标记的账单将确认，'+txt;
                }else if(this.curRole=='admin'||this.curRole=='sales'){
                    txt = '黄色标记的账单将确认，'+txt;
                }
                this.$confirm(txt,'提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消'
                }).then(()=>{
                    var arr=[];
                    this.confirmSelected.forEach(el=>{
                        arr.push(el.id)
                    })
                    if(this.curRole=='agent'){//伙伴确认账单
                        // result参数，2是确认账单，3是拒绝账单
                        agentConfirmBill({id:arr.join(','),result:2}).then(res=>{
                            if(res.code==2000){
                                this.$message.success('账单已确认成功！');
                                this.getData()
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }else{//销售或admin确认账单
                        saleConfirmBill({id:arr.join(',')}).then(res=>{
                            if(res.code==2000){
                                this.$message.success('账单已确认成功，请通知伙伴确认账单！');
                                this.getData()
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    }
                })
            },
            refuseBill(id){
                this.$confirm('拒绝该账单后，请及时联系销售人员，是否继续？','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消'
                }).then(()=>{
                    agentConfirmBill({id:id,result:3}).then(res=>{
                        if(res.code==2000){
                            this.$message.success('账单已拒绝，请通知销售查看账单！');
                            this.getData()
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                })
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit = 20
                this.getData()
                localStorage.setItem('billManageForm',JSON.stringify(this.formInline));
            },
            reset() {
                this.formInline = {
                    month:'',
                    region:'',
                    payer_id:'',
                    link_id:'',
                    sales:'',
                    agent_id:'',
                    billType:2,
                    page: 1,
                    limit: 20,
                    sortBy: '',
                    sortOrder: '',
                }
                this.pageparm={
                    page: 1,
                    limit: 20,
                    total: 0
                }
                this.getData()
            },
            //计算当前日期和筛选日期，如果当前月份-1=筛选月份，并且当前日期大于等于10号，则该月份账单可确认，同时要根据lock来确定
            //lock=0 ：账单初始状态，可以根据上一条来判断，满足则显示黄色，不满足则显示灰色
            //lock=1 ：销售已确认状态，此时显示橘色
            //lock=2 ：代理商已确认，此时显示绿色，此时该link对应的返点不可调整，该link对应的账单，复选框无法选中标绿的这条记录
            computeDate(){
                let date = new Date();
                //获取当前年份的后一年
                let endY =date.getFullYear();
                //获取当前月
                let endM = date.getMonth();
                let endD = date.getDate();
                let year='',month='';
                if(this.formInline.year){
                    year = Number(this.formInline.year.toString().substring(0,4));
                }
                if(this.formInline.month){
                    month = Number(this.formInline.month.toString().substring(4,6));
                }
                if(endY==year&&endM==month&&endD>=10){
                    return true
                }else if(endY==year&&endM>month){
                    return true;
                }else if(endY>year){
                    return true;
                }else{
                    return false;
                }
            },
            
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
            edit(row) {
                // 先获取返点数据
                getCheckRebateList({
                    link_id: row.linkId,
                    month: this.formInline.month,
                    page: 1,
                    limit: 1
                }).then(res => {
                    if(res.code == 2000 && res.data.length > 0) {
                        this.formData = JSON.parse(JSON.stringify(res.data[0]));
                        // 转换百分比
                        this.formData.discount1 = (Number(this.formData.discount1)*100).toFixed(2);
                        this.formData.discount2 = (Number(this.formData.discount2)*100).toFixed(2);
                        this.formData.discount3 = (Number(this.formData.discount3)*100).toFixed(2);
                        this.formData.sb_discount1 = (Number(this.formData.sb_discount1)*100).toFixed(2);
                        this.formData.sb_discount2 = (Number(this.formData.sb_discount2)*100).toFixed(2);
                        this.formData.sb_discount3 = (Number(this.formData.sb_discount3)*100).toFixed(2);
                        this.dialogVisible = true;
                    } else {
                        this.$message.error('获取返点数据失败');
                    }
                }).catch(err => {
                    this.$message.error('获取返点数据失败');
                });
            },
            cancel() {
                this.dialogVisible = false;
            },
            submit() {
                if(this.curRole!='agent'&&(Number(this.formData.discount2) > Number(this.formData.discount1))){
                    this.$message.warning('伙伴返点不能大于VAP返点！');
                }else if(this.curRole!='agent'&&(Number(this.formData.discount3) > Number(this.formData.discount2))){
                    this.$message.warning('客户返点不能大于伙伴返点！');
                }else{
                    var obj = JSON.parse(JSON.stringify(this.formData));
                    obj.discount1 = Number(obj.discount1)/100;
                    obj.discount2 = Number(obj.discount2)/100;
                    obj.discount3 = Number(obj.discount3)/100;
                    obj.sb_discount1 = Number(obj.sb_discount1)/100;
                    obj.sb_discount2 = Number(obj.sb_discount2)/100;
                    obj.sb_discount3 = Number(obj.sb_discount3)/100;
                    if(obj.monthEnd && obj.monthEnd.toString().indexOf('-')!=-1){
                        obj.monthEnd = Number(obj.monthEnd.split('-').join(''));
                    }else if(obj.monthEnd){
                        obj.monthEnd = Number(obj.monthEnd);
                    }
                    updateCheckRebate(obj).then(res=>{
                        if(res.code==2000){
                            this.dialogVisible = false;
                            this.$message.success('修改成功！');
                            this.getData();
                        }else{
                            this.$message.error('修改失败！');
                        }
                    })
                }
            },
            showInvoiceDialog(linkId) {
                this.selectedLinkId = linkId;
                this.invoiceDialogVisible = true;
            },
            handleClose() {
                this.invoiceDialogVisible = false;
                this.selectedLinkId = null;
            },
            // 处理排序
            handleSortChange(column) {
                if (column.prop) {
                    this.formInline.sortBy = column.prop;
                    this.formInline.sortOrder = column.order === 'descending' ? 'desc' : 'asc';
                } else {
                    this.formInline.sortBy = '';
                    this.formInline.sortOrder = '';
                }
                this.formInline.page = 1; // 排序时重置到第一页
                this.getData();
            },
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss" scoped>
.bill-manage-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    padding: 20px;
    
    // Table Card
    .table-card {
        margin-bottom: 50px;
        border-radius: 12px;
        border: none;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        
        .card-header {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            padding: 16px;
            
            .card-title {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 16px;
                width: 100%;
                
                .title-row {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    
                    .el-icon {
                        color: #409eff;
                        font-size: 18px;
                        margin-right: 8px;
                    }
                    
                    .record-count {
                        color: #6b7280;
                        font-size: 14px;
                        background: #f3f4f6;
                        padding: 4px 12px;
                        border-radius: 16px;
                        margin-left: 12px;
                        font-weight: 400;
                    }
                    
                    .action-buttons {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        margin-left: auto;
                        
                        .action-btn {
                            min-width: 100px;
                            height: 36px;
                            border-radius: 8px;
                            transition: all 0.3s ease;
                            font-size: 14px;
                            font-weight: 500;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            gap: 8px;
                            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                            
                            .custom-icon {
                                font-size: 18px;
                                transition: transform 0.3s ease;
                            }
                            
                            &:hover {
                                transform: translateY(-1px);
                                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                                
                                .custom-icon {
                                    transform: scale(1.1);
                                }
                            }
                            
                            &.el-button--primary {
                                background: linear-gradient(135deg, #409eff 0%, #1890ff 100%);
                                border: none;
                            }
                            
                            &.el-button--success {
                                background: linear-gradient(135deg, #67c23a 0%, #4caf50 100%);
                                border: none;
                            }
                            
                            &.el-button--warning {
                                background: linear-gradient(135deg, #e6a23c 0%, #f57c00 100%);
                                border: none;
                                
                                &.is-disabled {
                                    background: linear-gradient(135deg, #ffd599 0%, #ffb74d 100%);
                                    opacity: 0.7;
                                }
                            }
                        }
                    }
                }

                .filter-content {
                    width: 100%;
                    padding: 16px 0;
                    border-top: 1px solid #e5e7eb;
                    
                    .content-layout {
                        .filter-section {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            gap: 12px;
                            width: 100%;
                            
                            .filter-form {
                                display: flex;
                                flex: 1;
                                margin: 0;

                                .filter-grid {
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 12px;
                                    margin: 0;
                                    
                                    .filter-item {
                                        min-width: 140px;
                                        flex-shrink: 0;
                                        width: 200px;
                                        
                                        &.date-picker-container {
                                            width: 200px;
                                            margin-right: 12px;

                                            :deep(.el-date-editor.el-input),
                                            :deep(.el-date-editor.el-input__wrapper) {
                                                width: 100% !important;
                                            }

                                            :deep(.el-input__wrapper) {
                                                width: 100% !important;
                                            }

                                            .filter-form-item {
                                                width: 100%;
                                                margin-bottom: 0;

                                                :deep(.el-form-item__content) {
                                                    width: 100%;
                                                }
                                            }

                                            .date-picker {
                                                width: 100%;
                                            }
                                        }

                                        .filter-form-item {
                                            margin: 0;
                                            width: 100%;
                                        }
                                    }
                                }
                            }

                            .search-buttons {
                                display: flex;
                                gap: 8px;
                                flex-shrink: 0;
                                margin-left: 12px;

                                .search-btn,
                                .reset-btn {
                                    min-width: 70px;
                                    height: 32px;
                                    padding: 0 12px;
                                    font-size: 14px;
                                }
                            }
                        }
                    }
                }
            }
        }
        
        .table-container {
            overflow-x: auto;
            max-width: 100%;
            
            .modern-table {
                border-radius: 8px;
                overflow: hidden;
                min-width: 1000px;
                
                .el-table__header {
                    background: #f8fafc;
                    
                    th {
                        background: #f8fafc !important;
                        color: #374151;
                        font-weight: 600;
                        border-bottom: 2px solid #e5e7eb;
                    }
                }
                
                .el-table__body {
                    tr {
                        transition: all 0.3s ease;
                        
                        &:hover {
                            background: #f0f9ff !important;
                        }
                    }
                    
                    td {
                        border-bottom: 1px solid #f3f4f6;
                        padding: 2px 6px;
                        line-height: 1.2;
                        
                        .link-cell {
                            display: flex;
                            align-items: center;
                            gap: 4px;
                            min-height: 24px;
                            
                            .status-indicator {
                                .status-dot {
                                    width: 6px;
                                    height: 6px;
                                    border-radius: 50%;
                                    display: inline-block;
                                    
                                    &.info {
                                        background: #9ca3af;
                                    }
                                    
                                    &.warning {
                                        background: #f59e0b;
                                    }
                                    
                                    &.primary {
                                        background: #3b82f6;
                                    }
                                    
                                    &.danger {
                                        background: #ef4444;
                                    }
                                    
                                    &.success {
                                        background: #10b981;
                                    }
                                }
                            }
                            
                            .link-id {
                                font-family: 'Monaco', 'Menlo', monospace;
                                background: #f3f4f6;
                                padding: 4px 8px;
                                border-radius: 4px;
                                font-size: 12px;
                                color: #6b7280;
                                
                                &.clickable {
                                    cursor: pointer;
                                    transition: all 0.3s ease;
                                    
                                    &:hover {
                                        background: #409eff;
                                        color: white;
                                    }
                                }
                            }
                        }
                        
                        .cell-content {
                            min-height: 24px;
                            display: flex;
                            align-items: center;
                            .company-name {
                                font-weight: 500;
                                color: #1f2937;
                                display: block;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                max-width: 180px;
                            }
                            
                            .entity-tag {
                                background: #e0f2fe;
                                color: #0277bd;
                                border: none;
                                border-radius: 12px;
                                padding: 4px 8px;
                                font-weight: 500;
                            }
                            
                            .date-text {
                                font-family: 'Monaco', 'Menlo', monospace;
                                font-size: 13px;
                                color: #6b7280;
                            }
                        }
                        
                        .amount-cell {
                            min-height: 24px;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            .amount {
                                font-family: 'Monaco', 'Menlo', monospace;
                                font-weight: 600;
                                color: #1f2937;
                                
                                &.discount, &.saving-plan {
                                    color: #dc2626;
                                }
                                
                                &.total {
                                    color: #059669;
                                    font-size: 14px;
                                }
                            }
                        }
                        
                        .action-cell {
                            min-height: 24px;
                            .action-icon-btn {
                                padding: 2px 4px;
                            }
                        }
                    }
                }
            }
        }

        .table-footer {
            padding: 16px;
            border-top: 1px solid #e5e7eb;
            background: #f8fafc;
            
            .pagination-wrapper {
                display: flex;
                justify-content: center;

                .lyPagination-page {
                    background: transparent !important;
                    border: none !important;
                    box-shadow: none !important;
                    padding: 8px 16px !important;
                    
                    .page-box {
                        .el-pagination {
                            --el-pagination-font-size: 14px;
                            --el-pagination-button-height: 32px;
                            --el-pagination-button-width: 32px;
                            
                            .el-pagination__total {
                                margin-right: 16px;
                                color: #4b5563;
                                font-weight: 500;
                            }
                            
                            .el-pagination__sizes {
                                margin-right: 16px;
                                
                                .el-select .el-input {
                                    width: 110px;
                                    
                                    .el-input__inner {
                                        height: 32px;
                                        line-height: 32px;
                                        font-size: 14px;
                                    }
                                }
                            }
                            
                            button {
                                background: white;
                                border: 1px solid #e5e7eb;
                                border-radius: 6px;
                                margin: 0 4px;
                                color: #4b5563;
                                transition: all 0.2s ease;
                                
                                &:hover:not(:disabled) {
                                    color: #3b82f6;
                                    border-color: #3b82f6;
                                    background: #f0f9ff;
                                }
                                
                                &:disabled {
                                    background: #f3f4f6;
                                    border-color: #e5e7eb;
                                    color: #9ca3af;
                                }
                                
                                &.btn-prev, &.btn-next {
                                    padding: 0 12px;
                                    
                                    .el-icon {
                                        font-size: 12px;
                                    }
                                }
                            }
                            
                            .el-pager {
                                li {
                                    background: white;
                                    border: 1px solid #e5e7eb;
                                    border-radius: 6px;
                                    margin: 0 4px;
                                    color: #4b5563;
                                    font-size: 14px;
                                    min-width: 32px;
                                    transition: all 0.2s ease;
                                    
                                    &:hover:not(.is-active) {
                                        color: #3b82f6;
                                        border-color: #3b82f6;
                                        background: #f0f9ff;
                                    }
                                    
                                    &.is-active {
                                        background: #3b82f6;
                                        border-color: #3b82f6;
                                        color: white;
                                        font-weight: 600;
                                    }
                                }
                            }
                            
                            .el-pagination__jump {
                                margin-left: 16px;
                                color: #4b5563;
                                
                                .el-pagination__editor.el-input {
                                    width: 50px;
                                    margin: 0 8px;
                                    
                                    .el-input__inner {
                                        height: 32px;
                                        line-height: 32px;
                                        font-size: 14px;
                                        text-align: center;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    
    // Service Dialog
    .service-dialog {
        .el-dialog {
            border-radius: 12px;
            overflow: hidden;
            
            .el-dialog__header {
                background: linear-gradient(135deg, #409eff 0%, #1890ff 100%);
                color: white;
                padding: 20px 24px;
            }
            
            .el-dialog__body {
                padding: 24px;
                
                .service-table {
                    margin-bottom: 24px;
                    border-radius: 8px;
                    overflow: hidden;
                    
                    .el-table__header {
                        background: #f8fafc;
                        
                        th {
                            background: #f8fafc !important;
                            color: #374151;
                            font-weight: 600;
                        }
                    }
                }
                
                .service-form {
                    padding: 20px;
                    background: #f8fafc;
                    border-radius: 8px;
                    
                    .el-form-item {
                        margin-bottom: 16px;
                        
                        .el-form-item__label {
                            font-weight: 500;
                            color: #374151;
                        }
                        
                        .el-input__wrapper {
                            border-radius: 6px;
                            border: 1px solid #d1d5db;
                            transition: all 0.3s ease;
                            
                            &:focus-within {
                                border-color: #409eff;
                                box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
                            }
                        }
                    }
                }
            }
            
            .el-dialog__footer {
                background: #f8fafc;
                padding: 20px 24px;
                border-top: 1px solid #e5e7eb;
                
                .dialog-footer {
                    display: flex;
                    gap: 12px;
                    justify-content: flex-end;
                    
                    .el-button {
                        border-radius: 8px;
                        padding: 10px 20px;
                        font-weight: 500;
                        
                        &.el-button--primary {
                            background: linear-gradient(135deg, #409eff 0%, #1890ff 100%);
                            border: none;
                            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
                            
                            &:hover {
                                transform: translateY(-1px);
                                box-shadow: 0 4px 16px rgba(64, 158, 255, 0.4);
                            }
                        }
                    }
                }
            }
        }
    }
    
    // Responsive Design
    @media (max-width: 1200px) {
        .filter-content .filter-form .filter-grid {
            grid-template-columns: 1fr 1fr;
        }
    }
    
    @media (max-width: 768px) {
        padding: 16px;
        
        .filter-card {
            .card-header {
                flex-direction: column;
                align-items: stretch;
                gap: 12px;
                
                .card-actions {
                    justify-content: center;
                    
                    .el-button {
                        flex: 1;
                        max-width: 120px;
                    }
                }
            }
        }
        
        .filter-content {
            .content-layout {
                flex-direction: column;
                gap: 16px;
                
                .filter-section {
                    flex: none;
                    order: -1;
                }
            }
            
            .filter-form .filter-grid {
                grid-template-columns: 1fr;
                gap: 12px;
            }
            
            .action-buttons {
                flex-direction: column;
                
                .action-btn {
                    width: 100%;
                }
            }
        }
        
        .table-card .card-header {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
        }
    }
}
.edit-dialog {
    :deep(.el-dialog) {
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

        .el-dialog__header {
            margin: 0;
            padding: 20px 24px;
            background: linear-gradient(135deg, #1890ff 0%, #0960bd 100%);
            border: none;
            
            .dialog-header {
                .dialog-title {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin: 0;
                    font-size: 18px;
                    color: #fff;
                    font-weight: 500;

                    .el-icon {
                        font-size: 20px;
                    }

                    .dialog-subtitle {
                        font-size: 14px;
                        opacity: 0.9;
                        font-weight: normal;
                    }
                }
            }
        }

        .el-dialog__body {
            padding: 24px;

            .dialog-content {
                .form-section {
                    background: #f8fafc;
                    border-radius: 8px;
                    padding: 20px;
                    margin-bottom: 20px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .section-title {
                        margin: 0 0 20px;
                        font-size: 15px;
                        font-weight: 600;
                        color: #1f2937;
                        padding-bottom: 12px;
                        border-bottom: 1px solid #e5e7eb;
                    }

                    .el-form-item {
                        margin-bottom: 16px;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .el-form-item__label {
                            font-weight: 500;
                            color: #374151;
                        }

                        .el-input__wrapper {
                            box-shadow: none;
                            border: 1px solid #e5e7eb;
                            border-radius: 6px;
                            
                            &.is-focus {
                                border-color: #1890ff;
                            }
                        }

                        .disabled-input {
                            .el-input__wrapper {
                                background: #f3f4f6;
                            }
                        }

                        .el-switch {
                            --el-switch-on-color: #1890ff;
                        }
                    }
                }
            }
        }

        .el-dialog__footer {
            padding: 16px 24px;
            background: #f8fafc;
            border-top: 1px solid #e5e7eb;

            .dialog-footer {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .footer-note {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    color: #6b7280;
                    font-size: 13px;

                    .el-icon {
                        color: #f59e0b;
                    }
                }

                .footer-actions {
                    display: flex;
                    gap: 8px;

                    .el-button {
                        min-width: 90px;
                        border-radius: 6px;

                        &--primary {
                            background: #1890ff;
                            border: none;
                        }
                    }
                }
            }
        }
    }
    }
</style>
